const FONT_FAMILY = "'Raleway', sans-serif"

const FONT_WEIGHT = {
  regular: 400,
  medium: 500,
  semiBold: 600,
  bold: 700,
}

export { FONT_FAMILY, FONT_WEIGHT }
